<div class="passwordPage">
    <form (ngSubmit)="onSubmit()" #formHandler="ngForm">
        <div class="container">
            <div class="form">
                <div class="portalLogo mb-5" (click)="gotoHome()" style="cursor: pointer;" title="Home"></div>
                <div class="text-center">
                    <h2>{{ 'forgotPassword.title' | translate }}</h2>
                    <p>{{ 'forgotPassword.instruction' | translate }}</p>
                </div>
                <div class="form-group">
                    <input class="form-input" name="email" type="email" id="email-input"
                        placeholder="{{ 'forgotPassword.emailAddress' | translate }}" [(ngModel)]="email" #emailInput="ngModel"
                        required email/>
                    <label for="email-input" class="form_label">{{ 'forgotPassword.emailAddress' | translate }}</label>
                    <div [hidden]="emailInput.valid || emailInput.pristine"
                        class="alert alert-danger">
                        <span>{{ 'forgotPassword.enterValidEmail' | translate }}</span>
                    </div>
                </div>
                <div class="button-container mt-3">
                    <button [routerLink]="['']" class="primary-button back-button">
                        {{ 'forgotPassword.backToLogin' | translate }}
                    </button>
                    <button type="submit" [disabled]="!formHandler.form.valid" class="primary-button send-button" id="submit-button">
                        {{ 'forgotPassword.sendButton' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </form>
</div>